import { useHistory } from '@treams/treams-routes';

import * as graphql from 'generated/graphql';

import SettingsCollection from '../generic/SettingsCollection';

export default function SettingsTeams() {
	const history = useHistory();

	return (
		<SettingsCollection
			query={graphql.useTeamsQuery as any}
			lazyQuery={graphql.useTeamsLazyQuery as any}
			field="groups"
			translationKey="settings.teams"
			title={(team: graphql.Group) => team.name}
			link={(title) => `/settings/teams/${title.id}`}
			variables={{}}
			archive={graphql.useArchiveGroupMutation() as any}
			restore={graphql.useRestoreGroupMutation() as any}
			onAdd={() => history.push('/settings/teams/create')}
		/>
	);
}
